/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteTemplateOriginInfo_QuoteFragment = { __typename: 'Quote', id: string, templateOrigin?: { __typename: 'QuoteTemplateOrigin', templateId: string, versionNumber: number } | null };

export type QuoteTemplateOriginInfo_TemplateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type QuoteTemplateOriginInfo_TemplateQuery = { quoteTemplateLatestAvailableVersion: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateLatestAvailableVersionResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string } | null } };

export const QuoteTemplateOriginInfo_QuoteFragmentDoc = gql`
    fragment QuoteTemplateOriginInfo_Quote on Quote {
  id
  templateOrigin {
    templateId
    versionNumber
  }
}
    `;
export const QuoteTemplateOriginInfo_TemplateDocument = gql`
    query QuoteTemplateOriginInfo_Template($id: ID!) {
  quoteTemplateLatestAvailableVersion(id: $id) {
    ... on QuoteTemplateLatestAvailableVersionResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        title
      }
    }
  }
}
    `;

/**
 * __useQuoteTemplateOriginInfo_TemplateQuery__
 *
 * To run a query within a React component, call `useQuoteTemplateOriginInfo_TemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteTemplateOriginInfo_TemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteTemplateOriginInfo_TemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteTemplateOriginInfo_TemplateQuery(baseOptions: Apollo.QueryHookOptions<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables> & ({ variables: QuoteTemplateOriginInfo_TemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>(QuoteTemplateOriginInfo_TemplateDocument, options);
      }
export function useQuoteTemplateOriginInfo_TemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>(QuoteTemplateOriginInfo_TemplateDocument, options);
        }
export function useQuoteTemplateOriginInfo_TemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>(QuoteTemplateOriginInfo_TemplateDocument, options);
        }
export type QuoteTemplateOriginInfo_TemplateQueryHookResult = ReturnType<typeof useQuoteTemplateOriginInfo_TemplateQuery>;
export type QuoteTemplateOriginInfo_TemplateLazyQueryHookResult = ReturnType<typeof useQuoteTemplateOriginInfo_TemplateLazyQuery>;
export type QuoteTemplateOriginInfo_TemplateSuspenseQueryHookResult = ReturnType<typeof useQuoteTemplateOriginInfo_TemplateSuspenseQuery>;
export type QuoteTemplateOriginInfo_TemplateQueryResult = Apollo.QueryResult<QuoteTemplateOriginInfo_TemplateQuery, QuoteTemplateOriginInfo_TemplateQueryVariables>;